document.addEventListener("DOMContentLoaded", () => {
  const widget = document.querySelector("#boome-subscription-widget");
  if (!widget) return;

  const product = JSON.parse(widget.querySelector("[data-boome-product-json]").textContent);
  const form = document.querySelector('form[action*="/cart/add"]');
  if (!form) return;

  let sellingPlanInput = form.querySelector('input[name="selling_plan"]');

  if (!sellingPlanInput) {
    sellingPlanInput = document.createElement("input");
    sellingPlanInput.type = "hidden";
    sellingPlanInput.name = "selling_plan";
    form.appendChild(sellingPlanInput);
  }

  const money = cents =>
    new Intl.NumberFormat("fr-FR", {
      style: "currency",
      currency: "EUR"
    }).format(cents / 100);

  const getBottleCount = variant => {
    if (variant.title.includes("3")) return 3;
    if (variant.title.includes("6")) return 6;
    return 1;
  };

  const getMonthlyVariant = () =>
    product.variants.find(variant => variant.title.includes("1")) || product.variants[0];

  const getVariantById = id =>
    product.variants.find(variant => Number(variant.id) === Number(id));

  const getCurrentVariantId = () => {
    const input = form.querySelector('[name="id"]');
    return input ? Number(input.value) : Number(product.variants[0].id);
  };

  const setShopifyVariant = variantId => {
    const input = form.querySelector('[name="id"]');
    if (!input) return;

    input.value = variantId;
    input.dispatchEvent(new Event("change", { bubbles: true }));
  };

  const getDiscount = (price, compareAtPrice) => {
    if (!compareAtPrice || compareAtPrice <= price) return 0;
    return Math.round(100 - (price / compareAtPrice) * 100);
  };

  const updateStickySellingPlan = label => {
  document.querySelectorAll("[data-boome-sticky-selling-plan]").forEach(el => {
    el.textContent = label || "";
    el.hidden = !label;
  });
};

const updateStickyVariantTitle = title => {
  document.querySelectorAll("[data-boome-sticky-variant-title]").forEach(el => {
    el.textContent = title || "";
  });
};

const updateStickyPrice = html => {
  document.querySelectorAll("[data-boome-sticky-price]").forEach(el => {
    el.innerHTML = html || "";
  });
};

  const renderOtpCards = () => {
    widget.querySelectorAll("[data-variant-card]").forEach(card => {
      const variant = getVariantById(card.dataset.variantId);
      if (!variant) return;

      const bottleCount = getBottleCount(variant);
      const discount = getDiscount(variant.price, variant.compare_at_price);
      const unitPrice = Math.round(variant.price / bottleCount);

      card.querySelector("[data-variant-price]").textContent = money(variant.price);

      card.querySelector("[data-variant-compare]").textContent =
        discount ? money(variant.compare_at_price) : "";

      

      const benefit = card.querySelector("[data-variant-benefit]");

        if (benefit) {
        benefit.textContent = discount ? `${discount}% d'économie` : "";
        }

      
      const badge = card.querySelector("[data-variant-badge]");

      if (discount > 0) {
        badge.textContent = `-${discount}%`;
        } else {
        badge.textContent = "";
        }
    });
  };

  const updateOtpSummary = variant => {
    const summary = widget.querySelector("[data-otp-selected-summary]");
    if (!summary || !variant) return;

    const discount = getDiscount(variant.price, variant.compare_at_price);

    summary.innerHTML = `
      ${discount ? `<span class="boome-subscription__compare-price">${money(variant.compare_at_price)}</span>` : ""}
      <span class="boome-subscription__price">${money(variant.price)}</span>
    `;
  };

  const updateSubscription = () => {
    const monthlyVariant = getMonthlyVariant();
    const allocation = monthlyVariant.selling_plan_allocations?.[0];
    const subscriptionSection = widget.querySelector("[data-purchase-section='subscription']");

    if (!allocation) {
      subscriptionSection.style.display = "none";
      return;
    }

    subscriptionSection.style.display = "";

    const subscriptionPrice = widget.querySelector("[data-subscription-price]");
    const subscriptionCompare = widget.querySelector("[data-subscription-compare]");
    const subscriptionSaving = widget.querySelector("[data-subscription-saving]");
    const subscriptionUnitPrice = widget.querySelector("[data-subscription-unit-price]");

    if (subscriptionPrice) {
      subscriptionPrice.textContent = money(allocation.price);
    }

    if (subscriptionCompare) {
      subscriptionCompare.textContent = money(allocation.compare_at_price);
    }

    if (subscriptionUnitPrice) {
      subscriptionUnitPrice.textContent = `${money(allocation.price)} / flacon`;
    }

    if (subscriptionSaving) {
      const discount = getDiscount(allocation.price, allocation.compare_at_price);
      subscriptionSaving.innerHTML = `
        <span class="boome-subscription__variant-badge">-${discount}%</span>
        `;
            }
  };

  const setPurchaseOption = option => {
    widget.querySelectorAll("[data-purchase-section]").forEach(section => {
      section.classList.toggle("is-selected", section.dataset.purchaseSection === option);
    });

    widget.querySelectorAll('input[name="boome_purchase_option"]').forEach(radio => {
      radio.checked = radio.value === option;
    });

   if (option === "subscription") {
      const monthlyVariant = getMonthlyVariant();
      const allocation = monthlyVariant.selling_plan_allocations?.[0];

      setShopifyVariant(monthlyVariant.id);
      sellingPlanInput.disabled = false;
      sellingPlanInput.value = allocation ? allocation.selling_plan_id : "";
      setSelectedVariantCard(monthlyVariant.id);

      updateStickyVariantTitle(monthlyVariant.title);
      updateStickySellingPlan("Abonnement mensuel");

      updateSubscription();

        updateStickyPrice(
        widget.querySelector(
            ".boome-subscription__section--subscription .boome-subscription__header-price"
        )?.innerHTML
        );
      
      } else {
            sellingPlanInput.value = "";
            sellingPlanInput.disabled = true;

            preselectDefaultOtpCard();

            const selectedCard = widget.querySelector("[data-variant-card].is-selected");
            const selectedVariant = selectedCard
                ? getVariantById(selectedCard.dataset.variantId)
                : null;

            if (selectedVariant) {
                setShopifyVariant(selectedVariant.id);
                updateStickyVariantTitle(selectedVariant.title);
                updateStickyPrice(
                widget.querySelector("[data-otp-selected-summary]")?.innerHTML
                );
            }

            updateStickySellingPlan("");
            }
    };

  const setSelectedVariantCard = variantId => {
    widget.querySelectorAll("[data-variant-card]").forEach(card => {
      card.classList.toggle(
        "is-selected",
        Number(card.dataset.variantId) === Number(variantId)
      );
    });
  };

  const preselectDefaultOtpCard = () => {
    let defaultCard = widget.querySelector(
        '[data-variant-card][data-default-variant="true"]'
    );

    if (!defaultCard) {
        defaultCard = widget.querySelector("[data-variant-card]");
    }

    if (!defaultCard) return;

    const variant = getVariantById(defaultCard.dataset.variantId);
    if (!variant) return;

    setSelectedVariantCard(variant.id);
    updateOtpSummary(variant);
};
  const refresh = () => {
    const variant = getVariantById(getCurrentVariantId()) || product.variants[0];

    setSelectedVariantCard(variant.id);
    updateOtpSummary(variant);
    updateSubscription();
  };

  widget.querySelectorAll("[data-variant-card]").forEach(card => {
      card.addEventListener("click", () => {
        const variantId = Number(card.dataset.variantId);
        const variant = getVariantById(variantId);

        setPurchaseOption("otp");
        setShopifyVariant(variantId);
        setSelectedVariantCard(variantId);
        updateOtpSummary(variant);
        
        updateStickyPrice(
          widget.querySelector("[data-otp-selected-summary]")?.innerHTML
        );


        if (variant) {
          updateStickyVariantTitle(variant.title);
        }
      });
   });

  widget.querySelector("[data-purchase-section='otp']").addEventListener("click", event => {
    if (event.target.closest("[data-variant-card]")) return;
    setPurchaseOption("otp");
  });

  widget.querySelector("[data-purchase-section='subscription']").addEventListener("click", () => {
    setPurchaseOption("subscription");
  });

  document.addEventListener("change", () => {
    setTimeout(refresh, 100);
  });

  document.addEventListener("variant:change", () => {
    setTimeout(refresh, 100);
  });

  document.addEventListener("variant:changed", () => {
    setTimeout(refresh, 100);
  });

  const subscriptionModal = widget.querySelector("[data-boome-modal]");

  if (subscriptionModal) {
    const openModal = () => {
      subscriptionModal.hidden = false;
      document.body.style.overflow = "hidden";
    };

    const closeModal = () => {
      subscriptionModal.hidden = true;
      document.body.style.overflow = "";
    };

    widget.querySelectorAll("[data-boome-modal-open]").forEach(button => {
      button.addEventListener("click", openModal);
    });

    subscriptionModal.querySelectorAll("[data-boome-modal-close]").forEach(button => {
      button.addEventListener("click", closeModal);
    });

    document.addEventListener("keydown", event => {
      if (event.key === "Escape" && !subscriptionModal.hidden) {
        closeModal();
      }
    });
  }

renderOtpCards();
updateSubscription();
preselectDefaultOtpCard();
setPurchaseOption("subscription");


});